import { ChangePasswordByFindLinkPayload } from "@/data/payload/auth/change-password-by-find-link-payload";
import { CheckFindSnPhoneAuthCodePayload } from "@/data/payload/auth/check-find-sn-phone-auth-code-payload";
import { IssueFindSnPhoneAuthCodePayload } from "@/data/payload/auth/issue-find-sn-phone-auth-code-payload";
import { IssueWebFindSnEmailAuthCodePayload } from "@/data/payload/auth/issue-web-find-sn-email-auth-code-payload";
import { IssueWebFindSnLinkPayload } from "@/data/payload/auth/issue-web-find-sn-link-payload";
import { UserPasswordSource } from "@/data/source/user-password-source";
import { UserPasswordRepository } from "@/domain/repository/user-password-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class UserPasswordRepositoryImpl implements UserPasswordRepository {
  constructor(private readonly userPasswordSource: UserPasswordSource) {}

  async issueWebFindSnLink(
    payload: IssueWebFindSnLinkPayload,
  ): Promise<SATResult<void, SATError>> {
    const result = await this.userPasswordSource.issueWebFindSnLink(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async sendResetSnEmail(email: string): Promise<SATResult<void, SATError>> {
    return this.issueWebFindSnLink({ email });
  }

  async issueFindSnPhoneAuthCode(
    payload: IssueFindSnPhoneAuthCodePayload,
  ): Promise<SATResult<string, SATError>> {
    const result = await this.userPasswordSource.issueFindSnPhoneAuthCode(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(result.value.token);
  }

  async issueWebFindSnEmailAuthCode(
    payload: IssueWebFindSnEmailAuthCodePayload,
  ): Promise<SATResult<string, SATError>> {
    const result = await this.userPasswordSource.issueWebFindSnEmailAuthCode(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(result.value.token);
  }

  async checkFindSnPhoneAuthCode(
    payload: CheckFindSnPhoneAuthCodePayload,
  ): Promise<SATResult<string, SATError>> {
    const result = await this.userPasswordSource.checkFindSnPhoneAuthCode(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(result.value.token);
  }

  async changePassword(oldPassword: string, newPassword: string): Promise<SATResult<void, SATError>> {
    const result = await this.userPasswordSource.changePassword(oldPassword, newPassword);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async initPasswordByAccountSetupToken(
    token: string,
    newPassword: string,
  ): Promise<SATResult<void, SATError>> {
    const result = await this.userPasswordSource.initPasswordByAccountSetupToken(
      token,
      newPassword,
    );
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async changePasswordByVerificationToken(
    token: string,
    newPassword: string,
  ): Promise<SATResult<void, SATError>> {
    const result = await this.userPasswordSource.changePasswordByVerificationToken(
      token,
      newPassword,
    );
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async changePasswordByFindLink(
    payload: ChangePasswordByFindLinkPayload,
  ): Promise<SATResult<void, SATError>> {
    const result = await this.userPasswordSource.changePasswordByFindLink(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }
}
